import FlexSearch from 'flexsearch';
import { useEffect, useMemo, useState } from 'react';
import useSearch from '@hooks/search/useSearch';
import * as Obj from '@pkg/utils/objects';
import useDesignStore from '@/components/DesignContainer/hooks/useDesignStore';

const groupIndex = new FlexSearch.Index({
  tokenize: 'forward',
  context: true,
});

/**
 * @param {FlexSearch.Index} index
 * @param {Map} mapped
 * @returns {FlexSearch.Index}
 */
const updateIndex = (mapped) => {
  if (!Obj.isEmpty(groupIndex.register)) {
    for (const key in groupIndex.register) {
      if (!mapped.has(key)) {
        groupIndex.remove(key);
      }
    }
  }

  mapped.forEach(({ name }, key) => {
    if (!groupIndex.register?.[key]) {
      groupIndex.add(key, name);
    }
  });
};

const useGroupsIndex = () => {
  const snapshot = useDesignStore((state) => state.snapshot);
  const groups = useDesignStore((state) => state.snapshot?.entities?.groups);
  const [groupList, setGroupList] = useState([]);
  const [groupMap, setGroupMap] = useState(new Map());

  const searchGroups = useSearch({
    searchList: groupList,
    searchMap: groupMap,
    searchIndex: groupIndex,
  });

  const search = (searchTerm, validationFn) => {
    return searchGroups(searchTerm, validationFn);
  };

  const getGroup = (id) => {
    return groupMap.get(id);
  };

  useEffect(() => {
    if (!groups) {
      return;
    }

    const map = new Map(groupMap);
    const list = [...groupList];

    Object.values(groups).forEach(({ uuid, name }) => {
      const group = { uuid, name };
      const existingGroup = groupMap.get(uuid);
      if (existingGroup) {
        return;
      }

      map.set(uuid, { name });
      list.push(group);
      setGroupMap(map);
      setGroupList(list);
    });

    updateIndex(map);
  }, [groups]);

  return useMemo(
    () => ({
      groupList,
      groupMap,
      search,
      getGroup,
    }),
    [groupList?.length, groupIndex]
  );
};

export default useGroupsIndex;
